// extracted by mini-css-extract-plugin
export default {"background":"styles_background__GVj5P","image":"styles_image__AFeCM","container":"styles_container__82t17","title":"styles_title__UT6Bq"};